import api from "../utils/api";
import { RegisterUserModel } from "../register/user/RegisterUserModels";

export const registerUser = (identifier: string, data: RegisterUserModel): Promise<boolean> => {
    return api.post(`api/accounts/register/${identifier}/`, data).then(response => {
        return response.status === 200;
    });
}

export const deleteUser = (userId: string): Promise<boolean> => {
    return api.delete("api/companies/users", { id: userId }).then(response => {
        return response.status === 200;
    });
}


// WEBPACK FOOTER //
// ./src/api/accountApi.ts